require("../src/assets/js/polyfill.js"); // 去除touch事件谷歌提示
import Vue from 'vue'
import "element-ui/lib/theme-chalk/index.css"  //在App.vue之前引入，否则会覆盖自定义样式
import App from './App.vue'

import router from './router'
import store from './store'

import element from 'element-ui'

import axios from './axios'
import * as echarts from 'echarts'
import VueAMap from 'vue-amap'
import {HappyScroll} from 'vue-happy-scroll'
 
// import "./assets/bootstrap/bootstrap.css"   //加上可能会有样式冲突，需要检查
import "./assets/iconfont/iconfont.css"  //字体图标
import "./assets/dataIcon/iconfont.css"  //EMS数据字体图标
import "./assets/css/style.css"
import "./assets/css/input_style.css"
import "./assets/css/button.css"
import "./assets/js/global"
// import "./assets/js/my-api";
import "./util/my-const";
import "./assets/css/my_element_style.css"
// import 'default-passive-events'
import "./assets/js/drap.js" //引入自己封装的全局拖拽插件
import {VueJsonp} from "vue-jsonp"
//引入滚动组件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import  './util/rem'    
//注册腾讯位置服务
Vue.use(VueJsonp)

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts

Vue.use(element)
Vue.use(VueAMap)
Vue.component('happy-scroll', HappyScroll)  //自定义组件名

import 'vue-happy-scroll/docs/happy-scroll.css'  // 引入css
import "./assets/css/carbon.scss";
//初始化
VueAMap.initAMapApiLoader({
    //高德 key
    key: '6c0372b4b5c4fae81b94a27ffae86764',
    //高德 sdk 版本
    v: '1.4.15',
    //需要使用的的插件列表
    plugin: [//按照你的需要，引入地图的哪些功能，不需要下面这么多
        'Autocomplete',  //输入提示插件
        'PlaceSearch',  //POI搜索插件
        'Scale',  //右下角缩略图插件 比例尺
        'OverView',  //地图鹰眼插件
        'ToolBar',  //地图工具条
        'MapType',  //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        'PolyEditor',  //编辑 折线多，边形
        'CircleEditor',   //圆形编辑器插件
        'Geolocation',  //定位控件，用来获取和展示用户主机所在的经纬度位置
        'ControlBar',  //
        'Geocoder' //地理编码
    ],
    //UI组件库版本号
    uiVersion: '1.1'
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
